var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"marketing-container"},[_c('iframe',{staticClass:"marketing-iframe",attrs:{"src":'https://keap.page/rje671/leads.html',"frameborder":"0"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }